import { oneloginUrl, oneLoginClientId, oneloginRedirectUrl, apiUrl } from './config';

// Account
export const ACTIVATE_ACCOUNT = `${apiUrl}/activate-account`;
export const RESEND_ACTIVATION_LINK = `${apiUrl}/resend-activation-link`;
export const LOGIN_URL = `${apiUrl}/login`;
export const LOGOUT_URL = `${apiUrl}/logout`;
export const PASSWORD_RESET_CONFIRMATION = `${apiUrl}/password-reset-confirmation`;
export const PASSWORD_RESET_LINK = `${apiUrl}/password-reset-link`;
export const REGISTRATION_URL = `${apiUrl}/registration`;
export const USER_URL = `${apiUrl}/user`;
export const USER_INFO_URL = `${apiUrl}/userinfo`;

// People & Crafts
export const PEOPLE_URL = `${apiUrl}/user/people`;
export const PLEASURE_CRAFT_URL = `${apiUrl}/user/vessels`;
export const VESSELS_URL = `${apiUrl}/user/vessels`;
export const ZERO_T_RESPONSE_CODE = '0T';

// Voyage
export const UPT_CHECK_IN_PART = 'check-in';
export const USER_VOYAGE_REPORT_URL = `${apiUrl}/user/voyagereport`;
export const VOYAGE_REPORT_URL = `${apiUrl}/voyagereport`;
export const VOYAGE_API_PEOPLE_PART = 'people'; // allows you to build up `${VOYAGE_REPORT_URL}/${id}/${VOYAGE_API_PEOPLE_PART}

// Lookups
export const PORTS_URL = `${apiUrl}/ports`;

// API errors
export const DUPLICATE_PEOPLE_ERROR = 'Cannot add duplicate person to voyage report';
export const DUPLICATE_VESSEL_ERROR = 'A vessel with this registration already exists';
export const EXISTING_DOCUMENT_ID = 'A person with this document id already exists';
export const MAX_UNREGISTERED_VESSEL_ERROR =
  'Maximum number of Unregistered vessels cannot exceed 10';
export const PERSON_EXISTS_ERROR = 'This person already exists';
export const ONE_LOGIN_ERROR_TITLE = 'Sorry, there is a problem with your account';
export const ONE_LOGIN_HELP_LINK = 'Contact the support hub';
export const ONE_LOGIN_HELP_TEXT = 'to speak to someone about your account.';

// One login API url: spce between openid and email is important
export const ONE_LOGIN_AUTHORIZATION_URL = `${oneloginUrl}/authorize?response_type=code&scope=openid email&client_id=${oneLoginClientId}&redirect_uri=${oneloginRedirectUrl}`;
